// extracted by mini-css-extract-plugin
export default {"wrapper":"Categories_wrapper__qvM0U","button":"Categories_button__Z4G45","list":"Categories_list__H2mbu","item":"Categories_item__A0aop","active":"Categories_active__Bbe0Y"};